import React, { FC } from 'react';
import templateIds from '../../../../constants/templates.constants';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import Picture from '../../../@shared/picture';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { TLogoProps } from '../../types/lightHeader.types';

const Logo: FC<TLogoProps> = (props): JSX.Element => {
  const { logoImage, mobileLogoImage, logoLink } = props;
  const context = useSitecoreContext();
  const isHomePage = context?.sitecoreContext?.route?.templateId === templateIds.homeTemplateId;
  const LogoTag = isHomePage ? 'h1' : 'span';

  return (
    <LogoTag className="lightheader-navigation__logo">
      <RoutableSitecoreLink className="lightheader-navigation__logo__link" field={logoLink} editable={false}>
        <Picture
          editorialImageProps={{
            desktopImage: logoImage,
            mobileImage: mobileLogoImage,
            desktopTransformation: 'Size200',
            mobileTransformation: 'Size200',
            cssClassImageEl: 'lightheader-navigation__logo__image',
          }}
        />
      </RoutableSitecoreLink>
    </LogoTag>
  );
};

export default Logo;
